import { createSelector } from "reselect";

/**
 * selector to determine if patient overview is enabled
 */
export const patientOverviewEnabledSelector = createSelector(() => false);
